var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffDuty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00032 12.8337C10.222 12.8337 12.8337 10.222 12.8337 7.00032C12.8337 3.77866 10.222 1.16699 7.00032 1.16699C3.77866 1.16699 1.16699 3.77866 1.16699 7.00032C1.16699 10.222 3.77866 12.8337 7.00032 12.8337Z",
    fill: "#F8584B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffDuty);
export default __webpack_public_path__ + "static/media/off-duty.1f697408f97e9578685289d3f0763fef.svg";
export { ForwardRef as ReactComponent };